import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ReactComponent as CloseBtn } from '../../../../assets/icons/close.svg';
import PostLoginPostApi from '../../../../components/Api/PostLoginPostApi';
import BlackButton from '../../../../components/BlackButton';
import init from '../../AccessControl/Check';

const StoreCreateCategory = () => {

    const pageName = "Store Category Add";
    const isAccess = init(pageName);

    const navigate = useNavigate();
    const [name, setName] = useState("");
    const [position, setPosition] = useState("");

    const updatePosition = (event) => {
        let val = event.currentTarget.value;
        if( val !== "" ) {
            if( isNaN(val) ) {
                return;
            }

            val = parseInt(val);
        }

        setPosition(val);
    }


    const onSubmit = (e) => {
        e.preventDefault();

        if (name === "") {
            toast.error("Please enter category name.");
            return;
        }


        // CALL Create Category API
        PostLoginPostApi("category", JSON.stringify({ name: name, position: position }), 1).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {

                    toast.success("Category create successfully.");
                    navigate("/dashboard/store", {
                        state: {
                            tab: "store-category"
                        }
                    });
                    return;
                }

                toast.error(responseData["messages"].toString() + "");
            }
        }).catch((error) => {
            console.log(error);
        });
    }


    if (isAccess === false) {
        return (<>
            <table className="custom-details-table w-full mt-0 mb-2">
                <tbody>
                    <tr>
                        <td className="font-semibold text-base">
                            You do not have any access !
                        </td>
                    </tr>
                </tbody>
            </table>
        </>);
    }


    return (
        <div className="font-medium min-h-[100vh] w-[100%] h-[100%] custom-container-left custom-scroll-auto">
            <header className="p-4 border-b-2 border-dark-white mb-[60px]">
                <Link to="/dashboard/store" state={{ tab: "store-category" }}><CloseBtn className="float-left" /></Link>
                <p className="text-center">Create a Category</p>
            </header>
            <main className="max-w-2xl m-auto">

                <h1 className="text-lg">Category Name</h1>
                <form onSubmit={onSubmit}>
                    <div className="my-[10px]">
                        <input type="text" name="name" placeholder="Enter Category Name *" value={name} onChange={(event) => setName(event.currentTarget.value)} className="w-full mb-2.5 rounded border-solid border border-dark-white placeholder:text-ash" required />
                    </div>

                    <h1 className="text-lg">Display Position</h1>
                    <div className="my-[10px]">
                        <input type="text" name="name" placeholder="Enter Display Position (optional)" value={position} onChange={updatePosition} className="w-full mb-2.5 rounded border-solid border border-dark-white placeholder:text-ash" />
                    </div>


                    <BlackButton name="Add Category" />
                </form>

            </main>
        </div>
    );
};

export default StoreCreateCategory;